import React, { Component } from 'react';
import { AppSettings } from '../../configs';


class Footer extends Component {
    render() {
        return (
            <div id="sp-footer">
                <ul className="sp-footer-list">
                    <li className="sp-footer-item">
                        <div className="sp-copyright">© 2019 PTTPLC.</div>
                    </li>
                    <li className="sp-footer-item">
                        <div className="sp-footer-item-data"><i className="icon icon-footer-help" /> need help?</div>
                    </li>
                    <li className="sp-footer-item"><a href="tel:3456;" className="sp-footer-item-data"><i className="icon icon-footer-phone" /> 3456</a></li>
                    <li className="sp-footer-item"><a href="mailto:servicedesk@pttdigital.com;" className="sp-footer-item-data"><i className="icon icon-footer-mail" /> servicedesk@pttdigital.com</a></li>
                    <li><div>Version {AppSettings.appVersion}</div></li>
                </ul>
            </div>
        )
    }
}

export default Footer
